export default "__VITE_ASSET__ee694497__"